import { toNodes } from '../../dsp-graph/traversers.js';
import { Sequence } from '../../ast/declare.js';
import { commonsArrays, commonsWaitFrame } from '../../stdlib/commons/commons.js';
import { core } from '../../stdlib/core/core.js';
import { msg } from '../../stdlib/msg/msg.js';
import { proxyAsReadOnlyIndex } from '../proxies.js';

var precompileDependencies = (precompilation, minimalDependencies) => {
    const { settings, variableNamesAssigner, precompiledCodeAssigner } = precompilation;
    const dependencies = flattenDependencies([
        ...minimalDependencies,
        ..._collectDependenciesFromGraph(precompilation),
    ]);
    const globals = proxyAsReadOnlyIndex(precompilation.variableNamesIndex.globals);
    // Flatten and de-duplicate all the module's dependencies
    precompiledCodeAssigner.dependencies.ast = instantiateAndDedupeDependencies(dependencies, variableNamesAssigner, globals, settings);
    // Collect and attach imports / exports info
    precompiledCodeAssigner.dependencies.exports = collectAndDedupeExports(dependencies, variableNamesAssigner, globals, settings);
    precompiledCodeAssigner.dependencies.imports = collectAndDedupeImports(dependencies, variableNamesAssigner, globals, settings);
};
const instantiateAndDedupeDependencies = (dependencies, variableNamesAssigner, globals, settings) => {
    return Sequence(dependencies
        .map((globalDefinitions) => globalDefinitions.code(_getLocalContext(variableNamesAssigner, globalDefinitions), globals, settings))
        .reduce((astElements, astElement) => astElements.every((otherElement) => !_deepEqual(otherElement, astElement))
        ? [...astElements, astElement]
        : astElements, []));
};
const engineMinimalDependencies = () => [
    core,
    commonsArrays,
    commonsWaitFrame,
    msg,
];
const collectAndDedupeExports = (dependencies, variableNamesAssigner, globals, settings) => dependencies.reduce((exports, globalDefinitions) => globalDefinitions.exports
    ? [
        ...exports,
        ...globalDefinitions
            .exports(_getLocalContext(variableNamesAssigner, globalDefinitions), globals, settings)
            .filter((xprt) => exports.every((otherExport) => xprt !== otherExport)),
    ]
    : exports, []);
const collectAndDedupeImports = (dependencies, variableNamesAssigner, globals, settings) => dependencies.reduce((imports, globalDefinitions) => globalDefinitions.imports
    ? [
        ...imports,
        ...globalDefinitions
            .imports(_getLocalContext(variableNamesAssigner, globalDefinitions), globals, settings)
            .filter((imprt) => imports.every((otherImport) => imprt.name !== otherImport.name)),
    ]
    : imports, []);
const flattenDependencies = (dependencies) => dependencies.flatMap((globalDefinitions) => {
    if (globalDefinitions.dependencies) {
        return [
            ...flattenDependencies(globalDefinitions.dependencies),
            globalDefinitions,
        ];
    }
    else {
        return [globalDefinitions];
    }
});
const _collectDependenciesFromGraph = ({ graph, precompiledCodeAssigner, }) => {
    return toNodes(graph, precompiledCodeAssigner.graph.fullTraversal)
        .reduce((definitions, node) => {
        const precompiledNode = precompiledCodeAssigner.nodes[node.id];
        const precompiledNodeImplementation = precompiledCodeAssigner.nodeImplementations[precompiledNode.nodeType];
        return [
            ...definitions,
            ...(precompiledNodeImplementation.nodeImplementation
                .dependencies || []),
        ];
    }, []);
};
const _deepEqual = (ast1, ast2) => 
// This works but this flawed cause {a: 1, b: 2} and {b: 2, a: 1}
// would compare to false.
JSON.stringify(ast1) === JSON.stringify(ast2);
const _getLocalContext = (variableNamesAssigner, globalDefinitions) => ({
    ns: _getAssignerNamespace(variableNamesAssigner, globalDefinitions),
});
const _getAssignerNamespace = (variableNamesAssigner, globalDefinitions) => variableNamesAssigner.globals[globalDefinitions.namespace];

export { collectAndDedupeExports, collectAndDedupeImports, precompileDependencies as default, engineMinimalDependencies, flattenDependencies, instantiateAndDedupeDependencies };
